/**
 * 管理端图床图片批量下载（经 mgmt 代理，绕过跨域）
 */

export function sanitizeDownloadNamePart(val) {
  const s = String(val == null ? "" : val).trim();
  if (!s) return "";
  return s
    .replace(/[\\/:*?"<>|]/g, "_")
    .replace(/\s+/g, "")
    .replace(/_+/g, "_")
    .replace(/^_+|_+$/g, "");
}

/** 用若干段拼文件名前缀，自动过滤空段并做安全字符处理 */
export function joinDownloadNameParts(...parts) {
  const joined = parts
    .map((p) => sanitizeDownloadNamePart(p))
    .filter(Boolean)
    .join("-");
  return joined || "图片";
}

export function guessImageExt(mime, url) {
  if (mime && mime.includes("png")) return "png";
  if (mime && mime.includes("webp")) return "webp";
  if (mime && mime.includes("gif")) return "gif";
  const m = String(url || "").match(/\.(jpe?g|png|webp|gif)(\?|$)/i);
  if (m) {
    const ext = m[1].toLowerCase();
    return ext === "jpeg" ? "jpg" : ext;
  }
  return "jpg";
}

/**
 * @param {{ https: Function, apiUrl: string, url: string, filenameBase: string }} opts
 */
export async function downloadImageByUrl(opts) {
  const { https, apiUrl, url, filenameBase } = opts || {};
  if (!https || !apiUrl || !url || !filenameBase) {
    throw new Error("download failed");
  }
  const ext = guessImageExt(null, url);
  const filename = `${filenameBase}.${ext}`;
  const res = await https(apiUrl, { url, filename }, "FILE");
  if (!res || !res.data) {
    throw new Error("download failed");
  }
  const blob = res.data;
  const ct =
    (res.headers && (res.headers["content-type"] || res.headers["Content-Type"])) ||
    blob.type ||
    "";
  if (String(ct).indexOf("application/json") >= 0) {
    throw new Error("download failed");
  }
  if (!(blob instanceof Blob) || blob.size === 0) {
    throw new Error("download failed");
  }
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(objectUrl);
}

/**
 * 逐张下载；单张失败不中断
 * @returns {Promise<{ ok: number, total: number }>}
 */
export async function downloadImagesBatch(opts) {
  const { https, apiUrl, urls, nameBase, delayMs = 300 } = opts || {};
  const list = (urls || []).map((u) => String(u || "").trim()).filter(Boolean);
  const base = sanitizeDownloadNamePart(nameBase) || "图片";
  let ok = 0;
  for (let i = 0; i < list.length; i++) {
    try {
      await downloadImageByUrl({
        https,
        apiUrl,
        url: list[i],
        filenameBase: `${base}-${i + 1}`,
      });
      ok += 1;
      if (i < list.length - 1 && delayMs > 0) {
        await new Promise((r) => setTimeout(r, delayMs));
      }
    } catch (e) {
      // 单张失败继续其余
    }
  }
  return { ok, total: list.length };
}



// WEBPACK FOOTER //
// ./src/util/imageBatchDownload.js